import UsagerForm from "../components/UsagerForm";
import UsagerList from "../components/UsagerList";

export default function UsagersPage() {
    return (
      <div className=" w-[80%] h-[70%]  flex flex-col items-center  text-white absolute mt-[10%] ml-[10%] p-9">

            <UsagerForm />
            <UsagerList />
        </div>
    );
}
